import { META_PIXEL_ID } from './config'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

/**
 * Injects the standard Meta Pixel base code and fires a PageView event.
 * Safe to call multiple times — it only initializes the pixel once.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return /* eslint-disable */
  ;(function (f: any, b: any, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    // In some environments (e.g. iframe previews) there may be no existing
    // <script> tag to insert before — fall back to appending to <head>.
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}
